import React, { useEffect, useState } from 'react';
import {
  Container,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Button,
  Typography,
  Snackbar,
  Alert
} from '@mui/material';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import {BarLoader, GridLoader, HashLoader, MoonLoader, PropagateLoader, PuffLoader, PulseLoader} from 'react-spinners'
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Settlements() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [distributor, setDistributor] = useState('');
  const [pendings, setPendings] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null); // State for the selected row
  const [cashAmount, setCashAmount] = useState(0);
  const [lotteryAmount, setLotteryAmount] = useState(0);
  const [errorMessage, setErrorMessage] = useState('');
  const [pendingTotal,setPendingTotal] = useState(0)
  const [loading,setLoading] = useState(false);
  const [invoiceLoading,setInvoiceLoading] = useState(true);
  const [alertOpen,setAlertOpen] = useState(false)


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
        return;
    }
    setAlertOpen(false);
};

  const handleDistChange = (e) => {
    setDistributor(e.target.value);
  };

  useEffect(() => {
    axios.get("https://servermunidasa.ccsoftwares.com/settle/getAllPendings").then(res => {
      //console.log(res.data);
      setPendings(res.data);
      setInvoiceLoading(false)
    });
  }, []);


  const getALLpendings = () =>{
    axios.get("https://servermunidasa.ccsoftwares.com/settle/getAllPendings").then(res => {
      //console.log(res.data);
      setPendings(res.data);
      setInvoiceLoading(false)
    });
  }
  // Filter rows by both search term and selected distributor
  const filteredRows = pendings.filter((row) => 
    row.inv_no.includes(searchTerm) &&
    row.distributor.toLocaleLowerCase().includes(distributor.toLocaleLowerCase())
  );

  useEffect(() => {
    const total = filteredRows.reduce((acc, row) => acc + parseFloat(row.remaining), 0);
    setPendingTotal(total);
  }, [filteredRows]);


  // Function to handle row click
  const handleRowClick = (row) => {
    setSelectedRow(row);
    setCashAmount(''); // Reset cash amount
    setLotteryAmount(''); // Reset lottery amount
    setErrorMessage(''); // Reset error message
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const selectedInvoice = selectedRow;
    // //console.log(selectedInvoice)
    const totalAmount = parseFloat(selectedRow.remaining);
    const cash = parseFloat(cashAmount);
    const lottery = parseFloat(lotteryAmount);
    
    if (isNaN(cash) || isNaN(lottery)) {
      setErrorMessage('Please enter valid amounts.');
      return;
    }

    if (cash + lottery < totalAmount) {
      setErrorMessage(`Total amount to be paid Rs . ${parseFloat(totalAmount - (cash + lottery)).toFixed(2)}`);
      
    } else {
      setErrorMessage('');
    }

    const data = {
      distId:selectedInvoice.distId, 
      distributorName :selectedInvoice.distributor,
      qty:selectedInvoice.qty,
      total:selectedInvoice.total,
      cash:cash,
      lottery:lottery,
      pending:totalAmount  - (cash + lottery),
      inv_no : selectedInvoice.inv_no
    }

    setLoading(true)

    axios.post("https://servermunidasa.ccsoftwares.com/settle/add",data).then(res =>{
      setAlertOpen(true);
    }).catch(e =>{
      alert(e)
    })

    if (totalAmount  - (cash + lottery) === 0) {
      //console.log("Settled Invoice",selectedInvoice.inv_no)

      axios.put("https://servermunidasa.ccsoftwares.com/settle/udpateHeader",{inv_no : selectedInvoice.inv_no}).catch(e =>{
        alert(e)
      })
      
    }
    
    axios.put("https://servermunidasa.ccsoftwares.com/settle/partiallysettleInvoiceHeader",{inv_no : selectedInvoice.inv_no,remaining:data.pending}).catch(e =>{
      alert(e)
    })


    axios.get("https://servermunidasa.ccsoftwares.com/settle/getAllPendings").then(res => {
      //console.log(res.data);
      setPendings(res.data);
      setInvoiceLoading(false)
    });
    setLoading(false)


    // //console.log('Settlement successful:', { cash, lottery });
  };

  return (
    <Grid container style={{ padding: 20, backgroundColor: "white", fontFamily: 'Segoe UI', height: '100%', borderTopLeftRadius: 0, boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)' }}>
      <Snackbar open={alertOpen} autoHideDuration={6000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='success' sx={{ width: '100%' }}>
                Invoice Settled
            </Alert>
        </Snackbar>
      <Grid xs={12} md={12}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', height: 40 }}>
          <button
            style={{
              backgroundColor: '#FFFFFF',
              color: 'Black',
              border: 'none',
              cursor: 'pointer',
              fontSize: 30,
              marginTop: 10
            }}
            onClick={() => navigate(-1)}
          >
            <ArrowCircleLeftIcon fontSize='large' />
          </button>
          <div style={{ fontFamily: 'Segoe UI', fontSize: 28, fontWeight: '400' }}>
            Payment Settlements
          </div>
        </div>
      </Grid>

      <Grid md={4} xs={12}>
        <Container maxWidth="lg" style={{ height: '100vh', paddingTop: '2rem' }}>
          {/* Search and Distributor Filter */}
          <Grid container spacing={2} justifyContent="center" style={{ marginBottom: '1rem' }}>
            {/* Search Bar */}
            <Grid item xs={12} md={6}>
              <TextField
                variant="outlined"
                placeholder="Search by Invoice No"
                fullWidth
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </Grid>
            {/* Distributor Filter */}
            <Grid item xs={12} md={6}>
              <TextField
                variant="outlined"
                label="Search by Distributor"
                fullWidth
                value={distributor}
                onChange={handleDistChange}
              />
            </Grid>
          </Grid>

          {/* Table */}
          <TableContainer component={Paper} style={{ maxHeight: '65vh' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Distributor</TableCell>
                  <TableCell>Draw</TableCell>
                  <TableCell>Amount</TableCell>
                  <TableCell>invoice</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceLoading ? <>
                  <center><HashLoader size={30} color='black' style={{marginLeft : 30}}/></center>
                </> : <>
                {filteredRows.map((row) => (
                  <TableRow key={row.id} onClick={() => handleRowClick(row)} style={{ cursor: 'pointer' }}>
                    <TableCell>{row.distributor}</TableCell>
                    <TableCell>{row?.draw_date.split('T')[0]}</TableCell>
                    <TableCell style={{textAlign : 'right'}}>{row.remaining}</TableCell>
                    <TableCell style={{textAlign : 'right'}}>{row.inv_no.slice(-5)}</TableCell>
                  </TableRow>
                ))}
                </>}
              </TableBody>
            </Table>
          </TableContainer>
        <div style={{fontWeight : '600',marginLeft : 28}}>
         Total Pending  : Rs. {parseFloat(pendingTotal).toFixed(2)}
        </div>
        </Container>
      </Grid>

      {/* Description Section */}
      <Grid md={4} xs={12}>
        {selectedRow && (
          <div style={{ padding: 20, backgroundColor: '#f9f9f9', borderRadius: '8px', marginTop: '1rem' }}>
            <label style={{fontSize : 16,fontWeight : '600'}}>Invoice Details for Invoice : {selectedRow.inv_no}</label>
            <hr />
            <p><strong>Invoice No:</strong> {selectedRow.inv_no}</p>
            <p><strong>Inv Date:</strong> {selectedRow.creation_date.split('T')[0]}</p>
            <p><strong>Draw Date:</strong> {selectedRow.draw_date.split('T')[0]}</p>
            <p><strong>Quantity:</strong> {selectedRow.qty}</p>
            <p><strong>Status:</strong> {selectedRow.status === 0 ? 'Pending' : 'Settled'}</p>
            <p><strong>Total:</strong> {selectedRow.remaining}</p>
            <hr />

            <h2></h2>
            <p><strong>Distributor:</strong> {selectedRow.full_name}</p>
            <p><strong>Email Address:</strong> {selectedRow.Email_Address}</p>
            <p><strong>Phone Number:</strong> {selectedRow.Phone_Number}</p>
            <p><strong>Address:</strong> {selectedRow.address}</p>
          </div>
        )}
      </Grid>

      {/* Settle Section */}
      <Grid md={4} xs={12}>
        {selectedRow && (
          <div style={{ padding: 20 }}>
            <h2>Settle</h2>
            <p><strong>Total Amount:</strong> {selectedRow.remaining}</p>
            <form onSubmit={handleSubmit}>
              <TextField
                variant="outlined"
                label="Cash Amount"
                fullWidth
                type='number'
                value={cashAmount}
                onChange={(e) => setCashAmount(e.target.value)}
                style={{ marginBottom: '1rem' }}
                required
              />
              <TextField
                variant="outlined"
                label="Lottery Amount"
                fullWidth
                type='number'
                value={lotteryAmount}
                onChange={(e) => setLotteryAmount(e.target.value)}
                style={{ marginBottom: '1rem' }}
                required
              />
              {errorMessage && (
                <Typography color="error" variant="body2" style={{ marginBottom: '1rem' }}>
                  {errorMessage}
                </Typography>
              )}

              {loading ? <>
                <><PulseLoader size = {14} color='#00ffdd' speedMultiplier={1}/></>
              
              </> : <>
              <Button variant="contained" type="submit" color="primary">
                Submit
              </Button>
              </>}
            </form>
          </div>
        )}
      </Grid>
    </Grid>
  );
}

export default Settlements;
